// Scripted demo conversation — pages 24-28 du scope
// Phases : Création plan → Acceptation parent → Acceptation élève → Confirmation agent →
// Rappel 15 min → Démarrage → Suivi mi-séance → Bilan complet → Rapport parent
// Each step represents a chat bubble OR an orchestrator/dashboard event.

export const demoScript = [
  // -----------------------------------------------------------------
  // PHASE 1 — Création du plan (parent ↔ agent)
  // -----------------------------------------------------------------
  {
    type: "context",
    delay: 200,
    label: "Lundi — 19 h 02",
    sublabel: "Création du plan",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "Bonjour Marie 👋 Construisons ensemble le plan d'étude de Léa pour les prochaines semaines.",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 900,
    text: "Combien de minutes par séance souhaites-tu prévoir ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1300,
    typing: 700,
    text: "30 minutes",
    role: "Marie",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 800,
    text: "Parfait. Combien de séances par semaine ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1100,
    typing: 700,
    text: "4 — du lundi au jeudi",
    role: "Marie",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 900,
    text: "À quelle plage horaire préfère-t-elle étudier ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1100,
    typing: 700,
    text: "Entre 17 h et 18 h",
    role: "Marie",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 900,
    text: "Pour quelle durée totale ? (ex. 4, 8, 12 semaines)",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1100,
    typing: 600,
    text: "8 semaines",
    role: "Marie",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "Voici le plan que je te propose 👇",
  },
  {
    type: "plan_card",
    delay: 600,
  },
  {
    type: "dashboard",
    delay: 300,
    event: "plan_drafted",
    label: "Plan brouillon créé",
  },

  // -----------------------------------------------------------------
  // PHASE 2 — Acceptation par les deux parties
  // -----------------------------------------------------------------
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 900,
    text: "Marie, est-ce que tu acceptes ce plan ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1100,
    typing: 600,
    text: "Oui, j'accepte ✅",
    role: "Marie",
  },
  {
    type: "dashboard",
    delay: 300,
    event: "parent_accepted",
    label: "Parent : plan accepté",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1000,
    text: "Super 🙌 Je demande maintenant à Léa de l'accepter de son côté.",
  },
  {
    type: "context",
    delay: 800,
    label: "Léa reçoit le plan",
    sublabel: "Acceptation élève",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "Salut Léa 👋 Tu as reçu le plan d'étude convenu avec ta maman. Tu l'acceptes ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1400,
    typing: 700,
    text: "Oui, ça me va 👍",
    role: "Léa",
  },
  {
    type: "dashboard",
    delay: 300,
    event: "student_accepted",
    label: "Élève : plan accepté",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1300,
    text: "Ok parfait Léa 🎯 On fait 30 min, du lundi au jeudi entre 17 h et 18 h, pendant 8 semaines. Je t'envoie un message 15 min avant chaque séance.",
  },
  {
    type: "dashboard",
    delay: 300,
    event: "plan_active",
    label: "Plan actif ✅",
  },

  // -----------------------------------------------------------------
  // PHASE 3 — Le lendemain, rappel 15 min avant + démarrage
  // -----------------------------------------------------------------
  {
    type: "context",
    delay: 1100,
    label: "Mardi — 16 h 45",
    sublabel: "Rappel 15 minutes avant",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "🔔 Petit rappel Léa : tu commences ta séance dans 15 minutes (17 h – 18 h, 30 min). Prête ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1300,
    typing: 700,
    text: "Oui je me prépare 📚",
    role: "Léa",
  },
  {
    type: "context",
    delay: 800,
    label: "Mardi — 17 h 00",
    sublabel: "Démarrage de la séance",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 400,
    typing: 900,
    text: "C'est l'heure ! Veux-tu commencer maintenant ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1200,
    typing: 600,
    text: "Oui je commence ✏️",
    role: "Léa",
  },
  {
    type: "dashboard",
    delay: 300,
    event: "session_started",
    label: "Séance démarrée — Léa",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1000,
    text: "Parfait 💪 Bonne séance ! Je te recontacte à 17 h 30.",
  },

  // -----------------------------------------------------------------
  // PHASE 4 — Suivi de fin de séance + bilan détaillé
  // -----------------------------------------------------------------
  {
    type: "context",
    delay: 1100,
    label: "Mardi — 17 h 35",
    sublabel: "Suivi de fin de séance",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "🔔 As-tu terminé ta séance ? Combien de minutes as-tu faites ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1300,
    typing: 700,
    text: "Oui ! 35 minutes",
    role: "Léa",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 400,
    typing: 800,
    text: "Bravo 🎉 Qu'as-tu étudié ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1200,
    typing: 700,
    text: "Mathématiques — les fonctions",
    role: "Léa",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 400,
    typing: 900,
    text: "Sur 5, à quel point c'était difficile aujourd'hui ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1200,
    typing: 600,
    text: "3 / 5",
    role: "Léa",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 400,
    typing: 1000,
    text: "Qu'est-ce qui a été facile ou difficile ?",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1500,
    typing: 1000,
    text: "Les exercices 4 et 5 étaient un peu durs mais j'ai fini par comprendre.",
    role: "Léa",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 400,
    typing: 800,
    text: "🎙️ Si tu préfères, tu peux aussi m'envoyer un mémo vocal.",
  },
  {
    type: "chat",
    sender: "user",
    delay: 1200,
    voice: true,
    duration: "0:14",
    role: "Léa",
  },
  {
    type: "dashboard",
    delay: 300,
    event: "session_completed",
    label: "Séance complétée • 35 min • Maths",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "Bien joué Léa 🌟 Continue comme ça !",
  },

  // -----------------------------------------------------------------
  // PHASE 5 — Compilation + rapport au parent
  // -----------------------------------------------------------------
  {
    type: "context",
    delay: 1100,
    label: "Dimanche soir — Rapport hebdomadaire",
    sublabel: "Compilation pour Marie",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1100,
    text: "Bonjour Marie 👋 Voici le bilan de la semaine de Léa.",
  },
  {
    type: "report_card",
    delay: 500,
  },
  {
    type: "dashboard",
    delay: 300,
    event: "report_ready",
    label: "Rapport hebdomadaire envoyé",
  },
  {
    type: "chat",
    sender: "agent",
    delay: 500,
    typing: 1000,
    text: "Tendance : régularité 🟢. Bonne semaine Marie !",
  },
];

export const dashboardInitial = {
  studentName: "Léa",
  weekProgress: { planned: 0, completed: 0 },
  weekMinutes: 0,
  status: "Plan en préparation",
  lastSubject: "—",
  planActive: false,
  parentAccepted: false,
  studentAccepted: false,
};

export const planSummary = {
  duration: "30 min",
  days: "Lun → Jeu",
  window: "17 h – 18 h",
  weeks: "8 semaines",
  subject: "Général + Maths",
  total: 32, // 4 séances × 8 semaines
};
